import { Keyword, Perspective } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
const { either } = Parser;
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/perspective}
 *
 * @public
 */
export default Longhand.of(Keyword.of("none"), either(Keyword.parse("none"), Perspective.parseProp), (value) => value, { inherits: false });
//# sourceMappingURL=perspective.js.map